import React, { useContext } from 'react';
import {
	MuiAppContext,
	MuiPagination,
	MuiPaginationContext,
	MuiPaginationInfo,
	MuiPaginationItemsPerPageSelector,
	MuiPaginationIterator,
	MuiPaginationLoadingIndicator,
	MuiPaginationPageSelector,
	useWebapi,
} from '@lsoft/mui';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { renderItem } from '../Product/ShopProductGroupGrid';
import { Tr } from '@lsoft/translate';
import { useRouter } from 'next/router';
import _ from 'lodash';
import { Alert } from '@material-ui/lab';
import { Divider } from '@material-ui/core';
import { shop_search_query } from '@lsoft/shared/functions/search/search_query';
import { trEmptyResult } from '@lsoft/shared/translations/product.tr';
import { apiRenderProductsSearch } from '@lsoft/shared/api/render_products';

const EmptyResult = () => {
	return (
		<Grid
			container
			direction={'row'}
			justifyContent={'space-between'}
			alignItems={'center'}
			spacing={2}
		>
			<Grid item></Grid>
			<Grid item xs={12}>
				<Divider />
			</Grid>
			<Grid item xs={12}>
				<Alert variant={'standard'} severity={'info'}>
					<Tr tr={trEmptyResult} />
				</Alert>
			</Grid>
		</Grid>
	);
};

const ShopSearchViewContent = () => {
	return (
		<Grid container direction={'row'} spacing={2}>
			<Grid item xs={12}>
				<Grid
					container
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<Grid item></Grid>
					<Grid item>
						<Grid container direction={'row'} alignItems={'center'} spacing={2}>
							<Grid item>
								<MuiPaginationInfo />
							</Grid>
							<Grid item>
								<MuiPaginationPageSelector />
							</Grid>
						</Grid>
					</Grid>
					<MuiPaginationLoadingIndicator />
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Grid container direction={'row'} spacing={2}>
					<MuiPaginationIterator renderRow={renderItem} />
				</Grid>
			</Grid>

			<Grid item xs={12}>
				<Grid
					container
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<Grid item>
						<Grid container direction={'row'}>
							<Grid item>
								<MuiPaginationItemsPerPageSelector />
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Grid container direction={'row'} alignItems={'center'} spacing={2}>
							<Grid item>
								<MuiPaginationInfo />
							</Grid>
							<Grid item>
								<MuiPaginationPageSelector />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export const ShopSearchView = ({ q, paginationViewParams }) => {
	const webapi = useWebapi();
	const { scrollTop } = useContext(MuiAppContext);
	const router = useRouter();
	const options = _.assign(
		{},
		{
			SKIP: 0,
			LIMIT: 24,
			itemsPerPageDefault: 4,
			itemsPerPageOptions: [4, 24, 48],
		},
		paginationViewParams,
	);
	const viewName = 'SHOP_PRODUCT_GROUP_GRID';

	return (
		<MuiPagination
			key={q}
			options={options}
			router={router}
			loadData={async (skip, limit, sort) => {
				const query = shop_search_query(q, {});
				const ret = await apiRenderProductsSearch({
					skip,
					limit,
					query,
					sort,
					view: 'shop_grid',
				});
				return {
					IDS: ret.ids,
					DATA: ret.data,
					MAX_RESULTS: ret.max_results,
				};
			}}
			onPageChange={() => {
				scrollTop();
			}}
		>
			<MuiPaginationContext.Consumer>
				{({ view }) => {
					if (view.IDS.length === 0) return <EmptyResult />;
					return <ShopSearchViewContent />;
				}}
			</MuiPaginationContext.Consumer>
		</MuiPagination>
	);
};

ShopSearchView.propTypes = {
	q: PropTypes.string.isRequired,
	paginationViewParams: PropTypes.object,
};
ShopSearchView.defaultProps = {};
